// Copyright (c) 2016 Deere & Company

import exportToExcelActions from './export-to-excel-actions-list';

export default Object.freeze({
    ...exportToExcelActions,
    CREATE_ALERT_MESSAGE: 'CREATE_ALERT_MESSAGE',
    DECREASE_BUSY_COUNTER: 'DECREASE_BUSY_COUNTER',
    DELETE_ALERT_MESSAGE: 'DELETE_ALERT_MESSAGE',
    DISMISS_ALERT_MESSAGES: 'DISMISS_ALERT_MESSAGES',
    INCREASE_BUSY_COUNTER: 'INCREASE_BUSY_COUNTER',
    READ_CUSTOMER_SUCCESS: 'READ_CUSTOMER_SUCCESS',
    READ_FAVORITES: 'READ_FAVORITES',
    RESET_BUSY_COUNTER: 'RESET_BUSY_COUNTER',
    RESET_CKC_CUSTOMER_FAILURE: 'RESET_CKC_CUSTOMER_FAILURE',
    RESET_LATEST_PER_EDITED_UNIT_MEASUREMENTS: 'RESET_LATEST_PER_EDITED_UNIT_MEASUREMENTS',
    RESET_LATEST_PER_UNIT_MEASUREMENTS: 'RESET_LATEST_PER_UNIT_MEASUREMENTS',
    TOGGLE_DEALER_ACCOUNT_FACET_ITEMS: 'TOGGLE_DEALER_ACCOUNT_FACET_ITEMS',
    UPDATE_ADD_AMOUNT_OF_USE_AMOUNT: 'UPDATE_ADD_AMOUNT_OF_USE_AMOUNT',
    UPDATE_CKC_CUSTOMER_FAILURE: 'UPDATE_CKC_CUSTOMER_FAILURE',
    UPDATE_CLAIM_TYPES: 'UPDATE_CLAIM_TYPES',
    UPDATE_CSC_USER_ROUTING_INFO: 'UPDATE_CSC_USER_ROUTING_INFO',
    UPDATE_CUSTOMER_EDIT_MODAL_VISIBILITY: 'UPDATE_CUSTOMER_EDIT_MODAL_VISIBILITY',
    UPDATE_CUSTOMER_MODAL_VISIBILITY: 'UPDATE_CUSTOMER_MODAL_VISIBILITY',
    UPDATE_DEALER_ACCOUNT_FACET_INPUT: 'UPDATE_DEALER_ACCOUNT_FACET_INPUT',
    UPDATE_DEALER_ACCOUNT_FACET_ITEM: 'UPDATE_DEALER_ACCOUNT_FACET_ITEM',
    UPDATE_ERROR: 'UPDATE_ERROR',
    UPDATE_LATEST_EDITED_ADD_FILE_PER_UNIT_MEASUREMENTS: 'UPDATE_LATEST_EDITED_ADD_FILE_PER_UNIT_MEASUREMENTS',
    UPDATE_LATEST_EDITED_DELETE_FILE_PER_UNIT_MEASUREMENTS: 'UPDATE_LATEST_EDITED_DELETE_FILE_PER_UNIT_MEASUREMENTS',
    UPDATE_LATEST_EDITED_PER_UNIT_MEASUREMENTS: 'UPDATE_LATEST_EDITED_PER_UNIT_MEASUREMENTS',
    UPDATE_LATEST_PER_UNIT_MEASUREMENTS: 'UPDATE_LATEST_PER_UNIT_MEASUREMENTS',
    UPDATE_LINKS: 'UPDATE_LINKS',
    UPDATE_LIST_FILTER_BY: 'UPDATE_LIST_FILTER_BY',
    UPDATE_LIST_SORT_BY: 'UPDATE_LIST_SORT_BY',
    UPDATE_LIST_SORT_DIRECTION: 'UPDATE_LIST_SORT_DIRECTION',
    UPDATE_SAP_STATUS: 'UPDATE_SAP_STATUS',
    UPDATE_SESSION_EXPIRED_MODAL_VISIBILITY: 'UPDATE_SESSION_EXPIRED_MODAL_VISIBILITY',
    UPDATE_SUB_CLAIM_TYPES: 'UPDATE_SUB_CLAIM_TYPES'
});



// WEBPACK FOOTER //
// ./src/shared/actions-list.js